import { changeOrderNotRefUrl } from "@saleor/createOrChangeNotRefContract/urls";
export const changeOrderUrl = "/orders";
export const viewEditOrderUrl = `${changeOrderUrl}/change-order`;
export const notRefViewEditOrderUrl = `${changeOrderNotRefUrl}`;
